<section class="container mt-3">
    <div class="row">
        <!-- 參數列表 -->
        <div class="col-12 col-lg-3 col-md-4 mb-5">
            <mat-card class="example-card">
                <mat-card-header>
                    <mat-card-title>{{ 'AUTO_DRAW.RESULT.TITLE' | translate }}</mat-card-title>
                    <p
                        class="comment-icon m-0 mt-1 ms-2"
                        data-bs-toggle="tooltip"
                        data-bs-placement="right"
                        data-bs-html="true"
                        [title]="'AUTO_DRAW.RESULT.MEMO' | translate"
                    >?</p>
                </mat-card-header>
                <mat-card-content>
                    <table class="table">
                        <thead class="thead-white">
                            <tr class="text-center">
                                <th class="text-nowrap " scope="col">
                                    <mat-checkbox
                                        [(ngModel)]="selectAll"
                                        (ngModelChange)="toggleSelectAll($event)"
                                        class="mr-2"
                                        color="primary"
                                    ></mat-checkbox>
                                </th>
                                <th class="text-nowrap" scope="col">{{ "AUTO_DRAW.ENUM.TIM_KEY.NUMBER" | translate }}</th>
                                <th class="text-nowrap" scope="col">{{ "AUTO_DRAW.ENUM.TIM_KEY.SPEC" | translate }}</th>
                                <th class="text-nowrap" scope="col">K</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let tim of project.tims; let timIdx=index">
                                <tr class="tim-row text-center">
                                    <td>
                                        <mat-checkbox
                                            [hidden]="tim.tim_type === TIM_TYPE['TMP']"
                                            [disabled]="tim.tim_type === TIM_TYPE['TMP']"
                                            [(ngModel)]="tim.selected"
                                            class="mr-2"
                                            (ngModelChange)="changeSelectAll()"
                                            color="primary"
                                        ></mat-checkbox>
                                    </td>
                                    <td class="tim-td">{{ tim.number }}</td>
                                    <td class="tim-td">
                                        <ng-container *ngIf="tim.tim_type !== TIM_TYPE['TMP']; else tmpSpec">
                                            <span>{{ tim.length | number}}</span>
                                            <span>*</span>
                                            <span>{{ tim.width | number }}</span>
                                            <span>*</span>
                                            <span>{{ tim.thickness | number }}</span>
                                        </ng-container>
                                        <ng-template #tmpSpec>
                                            <span>-</span>
                                        </ng-template>
                                    </td>
                                    <td class="tim-td">
                                        {{tim.thermal_coefficient | number}}
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                    <!-- <div class="text-center">
                        <button class="btn btn-primary mr-3" (click)="algoDraw()">{{"MODEL.AUTO_DRAW" | translate}}</button>
                        <button class="btn btn-primary" (click)="algoQuote().subscribe()">{{"MODEL.AUTO_QUOTE" | translate}}</button>
                    </div> -->
                </mat-card-content>
                <mat-card-actions class="justify-content-center">
                    <button
                        mat-raised-button color="primary"
                        (click)="algoDraw()"
                    >{{"BUTTON.AUTO_DRAW" | translate}}</button>
                </mat-card-actions>
              </mat-card>
        </div>
        <!-- 圖紙顯示區塊 -->
        <div class="col-12 col-lg-9 col-md-8">
            <div class="workplace w-100 mb-3">
                <div
                    class="drag-element"
                    [style.width.%]="imageWidth"
                    [cdkDragFreeDragPosition]="dragPosition"
                    cdkDrag
                >
                    <img [src]="pngSafeLink" class="draw-img">
                </div>
            </div>
            <div class="controller d-flex justify-content-between">
                <div>
                    <button
                        class="btn btn-success me-3"
                        data-bs-toggle="modal"
                        data-bs-target="#resultModal"
                        [disabled]="!pngSafeLink"
                        (click)="openModal('DOWNLOAD')"
                    >{{"BUTTON.DOWNLOAD" | translate}}</button>
                    <button
                        type="button"
                        class="btn btn-success"
                        (click)="contactUsComponent.openModal()"
                    >{{"BUTTON.CONTACT" | translate}}</button>
                </div>
                <div>
                    <button class="btn btn-success me-3" (click)="changeImgStatus('RESET')">{{"BUTTON.RESET" | translate}}</button>
                    <button class="btn btn-success me-3" (click)="changeImgStatus('BIG')">+</button>
                    <button class="btn btn-success" (click)="changeImgStatus('SMALL')">-</button>
                </div>
            </div>
        </div>
    </div>
</section>

<app-contact-us [project]="project" [needCreateProject]="false"></app-contact-us>

<div
    class="modal fade"
    id="resultModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="resultModalLabel"
    aria-hidden="true"
>
    <div
        class="modal-dialog modal-dialog-scrollable"
        [ngClass]="{'modal-sm': openingModal==='DOWNLOAD'}"
    >
        <div class="modal-content" [ngSwitch]="openingModal">
            <ng-container
                *ngSwitchCase="'DOWNLOAD'"
                [ngTemplateOutlet]="downloadModal"
            ></ng-container>
        </div>
    </div>
</div>


<!-- 下載圖檔 -->
<ng-template #downloadModal>
    <div class="modal-header">
        <h5 class="modal-title" id="downLoadModalLabel">{{ "AUTO_DRAW.RESULT.DOWNLOAD.TITLE" | translate }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" #closeModalBtn></button>
    </div>
    <div class="modal-body">
        <div class="align-self-center">
            <label>{{ "AUTO_DRAW.RESULT.DOWNLOAD.TYPE" | translate }}</label>
            <mat-radio-group class="d-flex flex-column" [(ngModel)]="downloadFileType">
                <mat-radio-button class="mb-3" [value]="FILE_EXT_TYPE.PNG.CODE">PNG</mat-radio-button>
                <!-- <mat-radio-button class="mb-3" [value]="FILE_EXT_TYPE.DXF.CODE">DXF</mat-radio-button> -->
                <mat-radio-button class="mb-3" [value]="FILE_EXT_TYPE.PDF.CODE">PDF</mat-radio-button>
            </mat-radio-group>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">{{ "BUTTON.CANCEL" | translate }}</button>
        <button type="button" class="btn btn-primary" (click)="downloadFile(downloadFileType)">{{"BUTTON.DOWNLOAD" | translate}}</button>
    </div>
</ng-template>
